import React, { useEffect, useState } from 'react';

import AWS from 'aws-sdk';
import { get_ind_applicant_list } from '../../../api/Applicants/get_individual_applicant';
import { updateApplicantStatus } from "../../../api/Applicants/update_applicant_status"
import { Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { sendEmail } from '../../../api/MailSender/mailSender';


const ApplicantComp = ({ applicant, fetchApplicantList, setAApplicant, setRefresh }: any) => {
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  console.log(applicant, "see here")
  const [applicantInd, setapplicantInd] = useState<any>('');
  const [status, setStatus] = useState(applicant?.reason);
  const [reason, setReason] = useState('')
  const [applicantData, setApplicantData] = useState<any>({})
  const [openReason, setOpenReason] = useState(false)
  console.log(applicant, "see here")
  const rejectionTemplate =
  `<html>
      <head>
          <style>
              body {
                  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                  margin: 0;
                  padding: 0;
                  background-color: #f8f8f8;
              }
              .container {
                  width: 60%;
                  margin: auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border-radius: 8px;
                  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
                  margin-top: 50px;
                  margin-bottom: 50px;
                  overflow: hidden;
                  text-align: left;
              }
              .header {
                  background-color: #808080;
                  color: #ffffff;
                  text-align: center;
                  padding: 10px;
                  border-radius: 8px 8px 0 0;
                  margin-bottom: 20px;
              }
              .footer {
                  background-color: #fafafa;
                  color: #666666;
                  text-align: center;
                  padding: 10px;
                  border-radius: 0 0 8px 8px;
                  margin-top: 20px;
              }
              h1, h3 {
                  color: #333333;
                  margin-bottom: 10px;
              }
              p {    
                  color: #333333;
                  line-height: 1.6;
                  margin: 10px 0;
              }
              a {
                  color: #3498db;
              }
          </style>
      </head>
     <body>
    <div class="container">
        <div class="header">
            <h1>Interview Outcome</h1>
        </div>
        <p>Dear ${applicant.first_name} ${applicant.last_name},</p>
        <p>Thank you for applying for the <strong>${applicant.title}</strong> position at <strong>Insytix</strong>. After careful consideration, we regret to inform you that we are unable to move forward with your application at this time.</p>
        <p>We truly appreciate your time and effort and encourage you to explore future opportunities with us.</p>
        <p>Best regards,</p>
        <p>The Insytix Team</p>
        <div class="footer"> 
            <p>This is an automated message. Please do not reply.</p>
            <p>&copy; ${new Date().getFullYear()} Insytix. All rights reserved.</p>
        </div>
    </div>
</body>


  </html>`;
  

  const fetchApplicant = async () => {
    if (!applicant?.apply_id) {
      console.log("No applicant found to fetch");
      return;
    }
    try {
      const response = await get_ind_applicant_list(applicant?.apply_id);
      setapplicantInd(response[1]);
    } catch (error) {
      console.error(`Could not get data: ${error}`);
    }
  };

  useEffect(() => {
    if (applicant && applicant.apply_id) {
      fetchApplicant();
      // fetchApplicantList();
    }
  }, []);
  console.log(applicant, applicantInd, "#############")
  const onSubmit = async (data: any) => {
    try {
      const res = await updateApplicantStatus(applicant?.apply_id, {
        new_status: data.status,
        new_reason: data.reason
      });
      const dataLocal = JSON.stringify({
        status: data.status,
        reason: data.reason
      });
      if (res?.message === 'success') {
        localStorage.setItem('applicant', dataLocal);
        const localObject: any = localStorage.getItem('applicant');
        setApplicantData(JSON.parse(localObject));

        setRefresh(true)
        alert(`Reason added ${data.status}`);
        if (data.status === "REJECTED") {
          await sendEmail("workforce@insytix.com", [applicant.email], rejectionTemplate, `Your application status has ${data.status}`);
        }
        
      } else {
        alert('Error in changing status');
      }
    } catch (err) {
      console.log("ERROR in updating status", err);
    } finally {
      setOpenReason(false);
    }
  };


  useEffect(() => {
    console.log('Updated applicant details:', applicantInd);
  }, [applicantInd]);


  return (
    <>
      <div style={{ overflowY: 'scroll', height: '90vh', display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>

        <div style={{ alignItems: "flex-end", display: "flex", justifyContent: "flex-end" }}>
          <div style={{ position: 'absolute', top: '10px' }}>

            <button style={{ padding: "10px 30px", backgroundColor: 'blue', color: 'white', borderRadius: "10px" }}>
              <a
                href={applicant?.resume_cv ? applicant?.resume_cv : applicantInd?.resume_src}
                download={applicant?.resume_cv ? applicant?.resume_cv : applicantInd?.resume_src}
                target="_blank"
                style={{ textDecoration: 'none', color: 'white' }}
              >
                Download Resume
              </a>
            </button>

          </  div>
          <div style={{ marginTop: "100px", width: "50vw" }}>


            <table className="table flex-col table-striped table-bordered table-hover mx-auto w-100 mt-5" style={{ paddingTop: "10px" }}>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Status</strong>
                </th>
                <td className="data">{applicant?.status}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Applied On</strong>
                </th>
                <td className="data">{applicant?.created_at === "0000-00-00 00:00:00.000000" ? applicantInd?.created_at?.split(" ")?.[0] : applicantInd?.created_at?.split(" ")?.[0]}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Name</strong>
                </th>
                <td className="data">
                  {applicant?.first_name} {applicant?.last_name}
                </td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Email</strong>
                </th>
                <td className="data">{applicant?.email}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Phone Number </strong>
                </th>
                <td className="data">{applicant?.phonbe_number}</td>
              </tr>

              <tr className="tablerow">
                <th className="row-header">
                  <strong>Address</strong>
                </th>
                <td className="data">{applicant?.address}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Country</strong>
                </th>
                <td className="data">{applicant?.country}</td>
              </tr>
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>State</strong>
        </th>
        <td className="data">{applicant?.state}</td>
      </tr> */}
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>City</strong>
        </th>
        <td className="data">{applicant?.city}</td>
      </tr> */}
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Zipcode</strong>
                </th>
                <td className="data">{applicant?.zipcode}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>xth Markpercent</strong>
                </th>
                <td className="data">{applicant?.X_mark}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>xiith Markpercent</strong>
                </th>
                <td className="data">{applicant?.XII_mark}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>College</strong>
                </th>
                <td className="data">{applicant?.college}</td>
              </tr>
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Degree</strong>
                </th>
                <td className="data">{applicant?.degree}</td>
              </tr>
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>Stream</strong>
        </th>
        <td className="data">{applicant?.stream}</td>
      </tr> */}
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>Percentage</strong>
        </th>
        <td className="data">{applicant?.percentage}</td>
      </tr> */}
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>Experience</strong>
        </th>
        <td className="data">{applicant?.experience}</td>
      </tr> */}
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>Industry</strong>
        </th>
        <td className="data">{applicant?.industry}</td>
      </tr> */}
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Looking for</strong>
                </th>
                <td className="data">{applicant?.title}</td>
              </tr>
              {/* <tr className="tablerow">
        <th className="row-header">
          <strong>Apply Location</strong>
        </th>
        <td className="data">{applicant?.apply_location}</td>
      </tr> */}
              <tr className="tablerow">
                <th className="row-header">
                  <strong>Referral</strong>
                </th>
                <td className="data">{applicant?.referal}</td>
              </tr>

              <tr className="tablerow" onClick={() => setOpenReason(!openReason)}>
                <th className="row-header">
                  <strong>Reason</strong>
                </th>
                <td className="data">{applicant?.reason}</td>
                <td className="data" onClick={() => {
                  setOpenReason(!openReason)
                }}>Click to add</td>

              </tr>
            </table>
          </div>
          <div style={{ width: "300px", height: "500px", display: 'flexj', justifyContent: 'center', alignItems: 'center' }}>
            {
              openReason ?
                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* <input
        {...register('status')}
        defaultValue={applicant?.status}
        style={{ border: '1px solid black', alignItems: 'center', display: 'flex', padding: '10px' }}
      /> */}

                  <select
                    {...register('status')}
                    defaultValue={applicant?.status}
                  >
                    <option>Select an option</option>
                    <option value={"SELECTED"}>SELECTED</option>
                    <option value={"REJECTED"}>	REJECTED</option>
                    <option value={"INTERVIEWED"}>INTERVIEWED</option>
                    <option value={"WAITING"}>WAITING</option>
                    <option value={"APPLIED"}>APPLIED</option>
                  </select>
                  <textarea
                    {...register('reason')}
                    defaultValue={applicant?.reason}
                    style={{ border: '1px solid black', width: '300px', height: '100px', alignItems: 'center', display: 'flex', padding: '10px' }}
                  />
                  <Button type="submit">Submit</Button>
                </form>

                : null
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default ApplicantComp